import { NAModule } from '~/models/modules/NAModule.model';

export class BNDL extends NAModule {
    hasOperationReset = false;
    isWired = true;

}
